import React from "react";

import { LoginView } from "../../views";
import {
  SessionService,
  Auth0Service,
  LocalStorageService,
  BovedaApi,
} from "../../../services";
import { LocationUtil } from "../../../utils";
import { useTranslation } from "react-i18next";

class LoginAction extends React.Component {
  constructor(props) {
    super(props);
  }
  state = {
    loading: false,
    email: "",
    password: "",
    resetEmail: "",
    newEmail: "",
    newPassword: "",
    repeatNewPassword: "",
    loginAttepmtsCount: 0,
    templateRendering: "login", //Templates: login, register, forgotPassword
    loginSelected: "login-button-signin-signup-selected",
    hideTemplatesInvitedColaborator: false,
    registerSelected: "",
    errorForm: false,
    errorMessage: "",
    successForm: false,
    successMessage: "",
    loginShowPasswordIcon: "login-input-show-password-icon-desactive",
    loginShowPasswordRegisterIcon: "login-input-show-password-icon-desactive",
    loginShowPasswordRepeatRegisterIcon:
      "login-input-show-password-icon-desactive",
    userLocation: {},
    flags:[
      {
        language: 'es',
        src: `${process.env.REACT_APP_AWS_S3_BUCKET_URL}${process.env.REACT_APP_ICONS_LANGUAGE_MX}`,
        label: 'ES',
        status: true
      },
      {
        label: '|',
        status: false
      },
      {
        language: 'en',
        src: `${process.env.REACT_APP_AWS_S3_BUCKET_URL}${process.env.REACT_APP_ICONS_LANGUAGE_US}`,
        label: 'EN',
        status: false
      }
    ]
  };

  auth0Service = new Auth0Service();
  localStorageService = new LocalStorageService();
  sessionService = new SessionService(process.env.REACT_APP_MIFIRMA_API);
  bovedaApi = new BovedaApi(process.env.REACT_APP_MIFIRMA_API);

  /**
   * @author Alan Aguilar
   * @description ComponentDidMount method executed when the page is loaded for the first time
   * @updatedDate 26-08-2021
   * @memberof LoginAction
   */
  async componentDidMount() {
    let location = window.location.href;
    let isACustomPath = '?' + location.split("?")[1];
    let params = new URLSearchParams(isACustomPath)

    let language = this.localStorageService.getLocalStorageItem("preferredLanguage")
    this.setFlags(language)

    if (location && isACustomPath !== undefined) {
      if (params.get('email')) {
        this.setState({
          email: params.get('email'),
        });
      }
      if (params.get('registered') === 'true') {
        if (params.get('email')) {
          let cipheredEmail = Buffer.from(params.get('email'), 'base64').toString('ascii')
          this.setState({
            email: cipheredEmail,
          });
        } if (params.get('password')) {
          let cipheredPassword = Buffer.from(params.get('password'), 'base64').toString('ascii')
          this.setState({
            password: cipheredPassword,
          });
        }
        this.setState({ hideTemplatesInvitedColaborator: true });
        window.history.pushState("", document.title, window.location.pathname);
      } else if (params.get('newRegister') === "true") {
        this.setState({ templateRendering: "register" });
        window.history.pushState("", document.title, window.location.pathname);
      } else if (params.get("promotion") === "true") {
        this.localStorageService.setLocalStorageItem("promotion", true);
        if (params.get('email')) {
          this.setState({
            newEmail: params.get('email'),
            templateRendering: "register",
          });
        }
      }
    }
  }

  /**
   * @author Alan Aguilar
   * @description Handler method for LogIn an user in hibou.legal
   * @updatedDate 29-04-2022
   * @param {Object} e
   * @memberof LoginAction
   */
  onHandleLogin = async (e) => {
    e.preventDefault();

    let publicIP = await LocationUtil.getIP()
    publicIP = publicIP.data && publicIP.data.ip ? publicIP.data.ip : null

    this.setState({ loading: true });
    let { email, password } = this.state;

    email = email.trim();
    password = password.trim();

    email = email.toLowerCase();

    try {
      const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      this.localStorageService.setLocalStorageItem('timezone', timezone)

      // let loginBoveda = await this.bovedaApi.bovedaApiLogin(email, password);
      // if (loginBoveda.data.status === 200 && loginBoveda.data.data !== "") {
      //   let dataLoginBoveda = {
      //     access_token: loginBoveda.data.data.access_token,
      //     user: loginBoveda.data.data.user,
      //     password: loginBoveda.data.data.password,
      //   };
      //   this.localStorageService.setLocalStorageItem("bovedaToken", dataLoginBoveda);
      //   this.localStorageService.setLocalStorageItem("bovedaflagActive", false);
      // }

      let sessionLoginToken = await this.sessionService.sessionLogin(
        email,
        password,
        publicIP
      );
      if (sessionLoginToken && Number(sessionLoginToken.statusCode) === 200) {
        this.setState({
          errorForm: false,
          errorMessage: "",
        });

        //Verify if login need request OTP
        let requestOTP = sessionLoginToken.data.requestOTP
        let keyItem = (requestOTP) ? "requestOTP" : "token"
        let dataItem = (requestOTP) ? { requestOTP: true } : sessionLoginToken.data

        this.localStorageService.setLocalStorageItem(
          keyItem,
          dataItem
        );

        this.localStorageService.setLocalStorageItem(
          "user",
          sessionLoginToken.data.user
        )
        return window.location.reload();
      } else {
        if (
          sessionLoginToken &&
          Number(sessionLoginToken.statusCode) === -10
        ) {
          let { loginAttepmtsCount } = this.state;
          let count = loginAttepmtsCount + 1;
          this.setState({ loginAttepmtsCount: count });

          this.setState(
            {
              loading: false,
              errorForm: true,
              errorMessage: this.props.t("login.action.errorPassOrUser"),
            },
            () => {
              setTimeout(() => {
                this.setState({
                  errorForm: false,
                  errorMessage: "",
                });
              }, 7000);
            }
          );
          return false;
        } else if (
          sessionLoginToken &&
          Number(sessionLoginToken.statusCode) === 429
        ) {
          this.setState(
            {
              loading: false,
              errorForm: true,
              errorMessage: this.props.t("login.action.errorBlockUser", {
                email,
              }),
            },
            () => {
              setTimeout(() => {
                this.setState({
                  errorForm: false,
                  errorMessage: "",
                });
              }, 7000);
            }
          );
          return false;
        } else if (
          sessionLoginToken &&
          sessionLoginToken.message === "Email or password was not provided."
        ) {
          this.setState(
            {
              loading: false,
              errorForm: true,
              errorMessage: this.props.t("login.action.errorNoPassOrEmail"),
            },
            () => {
              setTimeout(() => {
                this.setState({
                  errorForm: false,
                  errorMessage: "",
                });
              }, 7000);
            }
          );
          return false;
        } else if (
          sessionLoginToken &&
          Number(sessionLoginToken.statusCode) === -2
        ) {
          this.setState(
            {
              loading: false,
              errorForm: true,
              errorMessage: this.props.t(
                "login.action.errorUserCreatedAndDisabled"
              ),
            },
            () => {
              setTimeout(() => {
                this.setState({
                  errorForm: false,
                  errorMessage: "",
                });
              }, 7000);
            }
          );
          return false;
        } else if (
          sessionLoginToken &&
          Number(sessionLoginToken.statusCode) === -5
        ) {
          this.setState(
            {
              loading: false,
              errorForm: true,
              errorMessage: this.props.t("login.action.error.maxim.attempts"),
            },
            () => {
              setTimeout(() => {
                this.setState({
                  errorForm: false,
                  errorMessage: "",
                });
              }, 7000);
            }
          );
          return false;
        } else if (
          sessionLoginToken &&
          Number(sessionLoginToken.statusCode) === 410
        ) {
          this.setState(
            {
              loading: false,
              errorForm: true,
              errorMessage: this.props.t("login.action.error.user.disabled")
            },
            () => {
              setTimeout(() => {
                this.setState({
                  errorForm: false,
                  errorMessage: "",
                });
              }, 7000);
            }
          );
          return false;
        } else if (
          sessionLoginToken &&
          Number(sessionLoginToken.statusCode) === 420
        ) {
          this.setState(
            {
              loading: false,
              errorForm: true,
              errorMessage: this.props.t("login.action.error.user.not.found")
            },
            () => {
              setTimeout(() => {
                this.setState({
                  errorForm: false,
                  errorMessage: "",
                });
              }, 7000);
            }
          );
          return false;
        }else if (
          sessionLoginToken &&
          Number(sessionLoginToken.statusCode) === 430
        ) {
          this.setState(
            {
              loading: false,
              errorForm: true,
              errorMessage: this.props.t("login.action.error.maxim.attempts")
            },
            () => {
              setTimeout(() => {
                this.setState({
                  errorForm: false,
                  errorMessage: "",
                });
              }, 7000);
            }
          );
          return false;
        }else if (
          sessionLoginToken &&
          Number(sessionLoginToken.statusCode) === 450
        ) {
          this.setState(
            {
              loading: false,
              errorForm: true,
              errorMessage: this.props.t("login.action.error.logs")
            },
            () => {
              setTimeout(() => {
                this.setState({
                  errorForm: false,
                  errorMessage: "",
                });
              }, 7000);
            }
          );
          return false;
        }else if (
          sessionLoginToken &&
          Number(sessionLoginToken.statusCode) === 460
        ) {
          this.setState(
            {
              loading: false,
              errorForm: true,
              errorMessage: this.props.t("login.action.error.send.otp")
            },
            () => {
              setTimeout(() => {
                this.setState({
                  errorForm: false,
                  errorMessage: "",
                });
              }, 7000);
            }
          );
          return false;
        } else {
          this.setState(
            {
              loading: false,
              errorForm: true,
              errorMessage: this.props.t("login.action.errorReload"),
            },
            () => {
              setTimeout(() => {
                this.setState({
                  errorForm: false,
                  errorMessage: "",
                });
              }, 7000);
            }
          );
          return false;
        }
      }
    } catch (err) {
      console.log(err);
      this.setState(
        {
          loading: false,
          errorForm: true,
          errorMessage: this.props.t("login.action.errorReload"),
        },
        () => {
          setTimeout(() => {
            this.setState({
              errorForm: false,
              errorMessage: "",
            });
          }, 7000);
        }
      );
      return false;
    }
  };

  /**
   * @author Alan Aguilar
   * @description Handler method for send a reset password email to an user registered in hibou.legal
   * @date 16-08-2021
   * @param {Object} e
   * @memberof LoginAction
   */
  onHandleResetPassword = async (e) => {
    e.preventDefault();
    this.setState({ loading: true });
    let { resetEmail } = this.state;

    resetEmail = resetEmail.trim();
    resetEmail = resetEmail.toLowerCase()

    if (
      !/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(
        resetEmail
      )
    ) {
      this.setState(
        {
          loading: false,
          errorForm: true,
          errorMessage: this.props.t("login.action.errorLossEmail"),
        },
        () => {
          setTimeout(() => {
            this.setState({
              errorForm: false,
              errorMessage: "",
            });
          }, 7000);
        }
      );
      return false;
    }

    try {
      let sessionChangePassword =
        await this.sessionService.sessionChangePassword(resetEmail);
      if (
        sessionChangePassword &&
        Number(sessionChangePassword.statusCode) === 200
      ) {
        this.setState(
          {
            templateRendering: "login",
            loading: false,
            errorForm: false,
            errorMessage: "",
            successForm: true,
            successMessage: this.props.t("login.action.successSendEmail"),
          },
          () => {
            setTimeout(() => {
              this.setState({
                successForm: false,
                successMessage: "",
              });
            }, 7000);
          }
        );
        return true;
      } else {
        let errorMessage =
          sessionChangePassword && sessionChangePassword.message
            ? sessionChangePassword.message
            : "An unknown error occurred.";
        throw new Error(errorMessage);
      }
    } catch (err) {
      console.log(err);
      this.setState(
        {
          loading: false,
          errorForm: true,
          errorMessage: this.props.t("login.action.errorChangePass"),
        },
        () => {
          setTimeout(() => {
            this.setState({
              errorForm: false,
              errorMessage: "",
            });
          }, 7000);
        }
      );
      return false;
    }
  };

  /**
   * @author Alan Aguilar
   * @description Handler method for register a new user in hibou.legal
   * @updatedDate 29-04-2022
   * @param {Object} e
   * @memberof LoginAction
   */
  onHandleSignUp = async (e) => {
    e.preventDefault();
    this.setState({ loading: true });
    let { newEmail, newPassword, repeatNewPassword } = this.state;

    newEmail = newEmail.trim();
    newPassword = newPassword.trim();
    repeatNewPassword = repeatNewPassword.trim();

    newEmail = newEmail.toLowerCase();

    if (newPassword === "" || newPassword.length <= 0) {
      this.setState(
        {
          loading: false,
          errorForm: true,
          errorMessage: this.props.t("login.action.errorSignUpPassword"),
        },
        () => {
          setTimeout(() => {
            this.setState({
              errorForm: false,
              errorMessage: "",
            });
          }, 7000);
        }
      );
      return false;
    }

    if (repeatNewPassword === "" || repeatNewPassword.length <= 0) {
      this.setState(
        {
          loading: false,
          errorForm: true,
          errorMessage: this.props.t("login.action.errorSignUpRepeatPassword"),
        },
        () => {
          setTimeout(() => {
            this.setState({
              errorForm: false,
              errorMessage: "",
            });
          }, 7000);
        }
      );
      return false;
    }

    if (
      newPassword.length < Number(process.env.REACT_APP_PASSWORD_LENGTH) ||
      repeatNewPassword.length < Number(process.env.REACT_APP_PASSWORD_LENGTH)
    ) {
      this.setState(
        {
          loading: false,
          errorForm: true,
          errorMessage: this.props.t("login.action.errorPassLength"),
        },
        () => {
          setTimeout(() => {
            this.setState({
              errorForm: false,
              errorMessage: "",
            });
          }, 7000);
        }
      );
      return false;
    }

    if (!(newPassword === repeatNewPassword)) {
      this.setState(
        {
          loading: false,
          errorForm: true,
          errorMessage: this.props.t("login.action.errorPass"),
        },
        () => {
          setTimeout(() => {
            this.setState({
              errorForm: false,
              errorMessage: "",
            });
          }, 7000);
        }
      );
      return false;
    }

    try {
      let sessionRegisterUser = await this.sessionService.sessionRegister(
        newEmail,
        newPassword
      );
      if (
        sessionRegisterUser &&
        Number(sessionRegisterUser.statusCode) === 200
      ) {
        this.setState({
          errorForm: false,
          errorMessage: "",
        });

        this.localStorageService.setLocalStorageItem(
          "auth0-data",
          sessionRegisterUser.data
        );
        this.localStorageService.setLocalStorageItem(
          "token",
          sessionRegisterUser.data
        );
        return window.location.reload();
      } else if (
        sessionRegisterUser &&
        sessionRegisterUser.message === "Email or password was not provided."
      ) {
        this.setState(
          {
            loading: false,
            errorForm: true,
            errorMessage: this.props.t("login.action.errorNoPassOrEmail"),
          },
          () => {
            setTimeout(() => {
              this.setState({
                errorForm: false,
                errorMessage: "",
              });
            }, 7000);
          }
        );
        return false;
      } else if (
        sessionRegisterUser &&
        sessionRegisterUser.message === "The user provided is disabled."
      ) {
        this.setState(
          {
            loading: false,
            errorForm: true,
            errorMessage: this.props.t(
              "login.action.errorUserCreatedAndDisabled"
            ),
          },
          () => {
            setTimeout(() => {
              this.setState({
                errorForm: false,
                errorMessage: "",
              });
            }, 7000);
          }
        );
        return false;
      }else if(sessionRegisterUser &&
        Number(sessionRegisterUser.statusCode) === 410) {
          this.setState(
            {
              loading: false,
              errorForm: true,
              errorMessage: this.props.t("login.action.error.user.exist")
            },
            () => {
              setTimeout(() => {
                this.setState({
                  errorForm: false,
                  errorMessage: "",
                });
              }, 7000);
            }
          );
          return false;
      }else if(sessionRegisterUser &&
        Number(sessionRegisterUser.statusCode) === 420) {
          this.setState(
            {
              loading: false,
              errorForm: true,
              errorMessage: this.props.t("login.action.error.govo.legal")
            },
            () => {
              setTimeout(() => {
                this.setState({
                  errorForm: false,
                  errorMessage: "",
                });
              }, 7000);
            }
          );
          return false;
      }else if(sessionRegisterUser &&
        Number(sessionRegisterUser.statusCode) === 430) {
          this.setState(
            {
              loading: false,
              errorForm: true,
              errorMessage: this.props.t("login.action.error.user.data"),
            },
            () => {
              setTimeout(() => {
                this.setState({
                  errorForm: false,
                  errorMessage: "",
                });
              }, 7000);
            }
          );
          return false;
      }else if(sessionRegisterUser &&
        Number(sessionRegisterUser.statusCode) === 440) {
          this.setState(
            {
              loading: false,
              errorForm: true,
              errorMessage: this.props.t("login.action.error.password"),
            },
            () => {
              setTimeout(() => {
                this.setState({
                  errorForm: false,
                  errorMessage: "",
                });
              }, 7000);
            }
          );
          return false;
      }else if(sessionRegisterUser &&
        Number(sessionRegisterUser.statusCode) === 450) {
          this.setState(
            {
              loading: false,
              errorForm: true,
              errorMessage: this.props.t("login.action.error.email.validation"),
            },
            () => {
              setTimeout(() => {
                this.setState({
                  errorForm: false,
                  errorMessage: "",
                });
              }, 7000);
            }
          );
          return false;
      }else{
        this.setState(
          {
            loading: false,
            errorForm: true,
            errorMessage: this.props.t("login.action.errorSignUpDefault"),
          },
          () => {
            setTimeout(() => {
              this.setState({
                errorForm: false,
                errorMessage: "",
              });
            }, 7000);
          }
        );
        return false;
      }
    } catch (err) {
      console.log(err);
      this.setState(
        {
          loading: false,
          errorForm: true,
          errorMessage: this.props.t("login.action.errorSignUpDefault"),
        },
        () => {
          setTimeout(() => {
            this.setState({
              errorForm: false,
              errorMessage: "",
            });
          }, 7000);
        }
      );
      return false;
    }
  };

  /**
   * @author Alan Aguilar
   * @description Handler method for capture the information in all inputs
   * @date 16-11-2020
   * @param {Object} e
   * @memberof LoginAction
   */
  onHandleGeneralChange = (e) => {
    this.setState({
      ...this.state,
      [e.target.id]: e.target.value,
    });
  };

  /**
   * @author Alan Aguilar
   * @description Handler method for change the form in the login card
   * @date 16-11-2020
   * @param {String} template
   * @memberof LoginAction
   */
  onHandleSelectTemplate = (template) => {
    switch (template) {
      case "login":
        this.setState({
          templateRendering: "login",
          errorForm: false,
          loginSelected: "login-button-signin-signup-selected",
          registerSelected: "",
        });
        break;
      case "register":
        this.setState({
          templateRendering: "register",
          errorForm: false,
          loginSelected: "",
          registerSelected: "login-button-signin-signup-selected",
        });
        break;
      case "forgotPassword":
        this.setState({
          templateRendering: "forgotPassword",
          errorForm: false,
        });
        break;
      default:
        break;
    }
  };

  /**
   * @author Alan Aguilar
   * @description Handler method to hide and show the label error
   * @date 16-11-2020
   * @memberof LoginAction
   */
  onHandleHideError = () => {
    this.setState({
      errorForm: false,
      errorMessage: "",
    });
  };

  /**
   * @author Alan Aguilar
   * @description Handler method to hide and show the label success
   * @date 16-11-2020
   * @memberof LoginAction
   */
  onHandleHideSuccess = () => {
    this.setState({
      successForm: false,
      successMessage: "",
    });
  };

  /**
   * @author Adrian Montemayor
   * @description Handler method to run when they press the button "Enter"
   * @date 21-11-2020
   * @memberof LoginAction
   */
  onHandleSignUpKeypress = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      this.onHandleSignUp(e);
    }
  };

  onHandleLoginKeypress = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      this.onHandleLogin(e);
    }
  };

  onHandleResetPasswordKeypress = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      this.onHandleResetPassword(e);
    }
  };

  /**
   * @author Alan Aguilar
   * @description Handler method to hide and show the password icon and text in Login form
   * @date 16-11-2020
   * @memberof LoginAction
   */
  onHandleShowPassword = () => {
    let { loginShowPasswordIcon } = this.state;
    let inputPassword = document.querySelector("#password");

    if (
      loginShowPasswordIcon === "login-input-show-password-icon-desactive" &&
      inputPassword.type === "password"
    ) {
      inputPassword.type = "text";
      this.setState({
        loginShowPasswordIcon: "login-input-show-password-icon-active",
      });
    } else {
      inputPassword.type = "password";
      this.setState({
        loginShowPasswordIcon: "login-input-show-password-icon-desactive",
      });
    }
  };

  /**
   * @author Alan Aguilar
   * @description Handler method to hide and show the newPassword icon and text in Register form
   * @date 16-11-2020
   * @memberof LoginAction
   */
  onHandleShowPasswordRegister = () => {
    let { loginShowPasswordRegisterIcon } = this.state;
    let inputPassword = document.querySelector("#newPassword");

    if (
      loginShowPasswordRegisterIcon ===
      "login-input-show-password-icon-desactive" &&
      inputPassword.type === "password"
    ) {
      inputPassword.type = "text";
      this.setState({
        loginShowPasswordRegisterIcon: "login-input-show-password-icon-active",
      });
    } else {
      inputPassword.type = "password";
      this.setState({
        loginShowPasswordRegisterIcon:
          "login-input-show-password-icon-desactive",
      });
    }
  };

  /**
   * @author Alan Aguilar
   * @description Handler method to hide and show the repeatPassword icon and text in Register form
   * @date 16-11-2020
   * @memberof LoginAction
   */
  onHandleShowPasswordRepeatRegister = () => {
    let { loginShowPasswordRepeatRegisterIcon } = this.state;
    let inputPassword = document.querySelector("#repeatNewPassword");

    if (
      loginShowPasswordRepeatRegisterIcon ===
      "login-input-show-password-icon-desactive" &&
      inputPassword.type === "password"
    ) {
      inputPassword.type = "text";
      this.setState({
        loginShowPasswordRepeatRegisterIcon:
          "login-input-show-password-icon-active",
      });
    } else {
      inputPassword.type = "password";
      this.setState({
        loginShowPasswordRepeatRegisterIcon:
          "login-input-show-password-icon-desactive",
      });
    }
  };

  setFlags = (language) => {
    if(!language) return
    let flags = this.state.flags.map((flag) => {
      flag.status = (language === flag.language) ? true : false
      return flag
    })

    this.setState({
      flags
    })
  }

  render() {
    return (
      <LoginView
        {...this.state}
        onHandleLogin={this.onHandleLogin}
        onHandleResetPassword={this.onHandleResetPassword}
        onHandleSignUp={this.onHandleSignUp}
        onHandleSelectTemplate={this.onHandleSelectTemplate}
        onHandleGeneralChange={this.onHandleGeneralChange}
        onHandleSignUpKeypress={this.onHandleSignUpKeypress}
        onHandleLoginKeypress={this.onHandleLoginKeypress}
        onHandleResetPasswordKeypress={this.onHandleResetPasswordKeypress}
        onHandleHideError={this.onHandleHideError}
        onHandleHideSuccess={this.onHandleHideSuccess}
        onHandleShowPassword={this.onHandleShowPassword}
        onHandleShowPasswordRegister={this.onHandleShowPasswordRegister}
        onHandleShowPasswordRepeatRegister={
          this.onHandleShowPasswordRepeatRegister
        }
        setFlags={this.setFlags}
      />
    );
  }
}

function LoginActionContainer(props) {
  const { t } = useTranslation();
  return <LoginAction {...props} t={t} />;
}

export { LoginActionContainer as default };
